export default __webpack_public_path__ + "static/B0032-ec02041d7fdafc735b25c692699a9357.png";